import { getRunTimeBizComponent } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position/display-position';
import './cell.scss';
import { config as enumerationConfig } from './enumeration/view';
export const allCellMap = {
    text: {
        componentName: 'text',
        position: DisplayPosition.tableCell,
    },
    ellipsis: {
        componentName: 'ellipsis',
        position: DisplayPosition.tableCell,
    },
    number: {
        componentName: 'number',
        position: DisplayPosition.tableCell,
    },
    currency: {
        componentName: 'currency',
        position: DisplayPosition.tableCell,
    },
    'currency-with-unit': {
        componentName: 'currency-with-unit',
        position: DisplayPosition.tableCell,
    },
    percent: {
        componentName: 'percent',
        position: DisplayPosition.tableCell,
    },
    bank: {
        componentName: 'bank',
        position: DisplayPosition.tableCell,
    },
    date: {
        componentName: 'date',
        position: DisplayPosition.tableCell,
    },
    'date-time': {
        componentName: 'date-time',
        position: DisplayPosition.tableCell,
    },
    tag: {
        componentName: 'tag',
        position: DisplayPosition.tableCell,
    },
    progress: {
        componentName: 'progress',
        position: DisplayPosition.tableCell,
    },
    enumeration: enumerationConfig,
    user: {
        componentName: 'user',
        position: DisplayPosition.tableCell,
    },
    'multiple-text': {
        componentName: 'multiple-text',
        position: DisplayPosition.tableCell,
    },
    'image-text': {
        componentName: 'image-text',
        position: DisplayPosition.tableCell,
    },
    file: {
        componentName: 'file',
        position: DisplayPosition.tableCell,
    },
};
// 获取button的node
export function getRunTimeCell(format) {
    let result;
    if (format) {
        result = allCellMap[format];
        if (!result) {
            result = getRunTimeBizComponent(format);
        }
    }
    return result;
}
